import ExportServicePopup from "@/Administration/Components/Services/ExportServicePopup/ExportServicePopup";
import { AdminServiceGridSortColumn } from "@/Administration/Models/Enums/AdminServiceGridSortColumn";
import { IServiceComboGridModel } from "@/Administration/Models/UI/ServiceCombo/IServiceComboGridModel";
import { Client } from "@/Common/Api/Client";
import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { NotificationConfigurationCompositeDto, NotificationConfigurationDto } from "@/Common/Api/Services/Dto/NotificationConfigurationDto";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { SpanControl } from "@/Common/Components/SpanControl";
import { CommonTableHeaderComponent } from "@/Common/Components/Tables/CommonTableHeaderComponent";
import { MyleTable } from "@/Common/Components/Tables/MyleTable";
import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { BaseServiceComboDefinitionModel, IComboOrServiceItem } from "@/Common/Models/Services/BaseServiceDefinitionModel";
import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import { ServiceOrComboTableItem } from "@/Common/Models/Services/ServiceOrComboTableItem";
import { SortDirection } from "@/Common/Models/UI/Enums";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { Server } from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { NotificationConfiguration } from "../NotificationConfiguration/NotificationConfiguration";
import { NotificationConfigurationInput, SaveNotificationConfigurationResponse } from "../NotificationConfiguration/NotificationConfiguration.types";
import { EditOnlineDetailsComponent } from "./EditOnlineDetailsComponent";
import { EditServiceComponent } from "./EditServiceComponent";
import { ServiceComboSearchSettings } from "./ServiceComboSearchSettings";

import "./ServiceComboTabView.css";

import img_icon_pictogrammemyle_emploisdutemps_assigne from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Assigne.png";
import img_icon_pictogrammemyle_emploisdutemps_clinique from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Clinique.png";
import img_icon_pictogrammemyle_emploisdutemps_organization from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Organization.png";
import img_icon_pictogrammemyle_emploisdutemps_ouvert from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Ouvert.png";
import img_icon_pictogrammemyle_emploisdutemps_rdvonline from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-RDVOnline.png";
import img_icon_pictogrammemyle_emploisdutemps_rdvurgent from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-RDVUrgent.png";
import img_icon_pictogrammemyle_emploisdutemps_site from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Site.png";
import img_icon_pictogrammemyle_emploisdutemps_teleconsultation from "@/Globals/_images/icons/admin/PictogrammeMYLE-EmploisDuTemps-Teleconsultation.png";
import img_icon_questionnaire from "@/Globals/_images/icons/questionnaire.png";

interface NotificationConfigurationModal {
    show: boolean;
    serviceOrCombo: ServiceOrComboTableItem<IComboOrServiceItem> | null;
    notificationConfiguration: NotificationConfigurationInput | null;
    defaultNotificationConfiguration: NotificationConfigurationCompositeDto | null;
}

interface IServiceComboTabViewProps {
    model: IServiceComboGridModel;
    serviceDefinitions: Immutable.List<ServiceDefinitionModel>;
    serviceComboDefinitions: Immutable.List<ServiceComboDefinitionModel>;
    showDefaultNotificationConfigCheckboxes?: boolean;
}

class ServiceComboTabView extends React.Component<IServiceComboTabViewProps, never> {
    private helper: MyleHelper = new MyleHelper();
    private saveOptionKey: string = "AdminServiceComboGrid";
    private isNotificationsEnabled = cacheStore.ClinicSettings.EnableNotificationConfiguration;

    public componentDidMount(): void {
        window.setTimeout(() => {
            let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.RefreshGrid);
            operation.AddItem("reload", false);
            operation.AddItem("model", this.props.model);
            LocalEventDispatcher.dispatch(operation);
        }, 5);

        window.setTimeout(() => {
            $(window).trigger("resize");
        }, 50);
    }

    public render(): JSX.Element {
        // hide Ad-Hoc in table
        const services = this.props.model.get("FilteredCombosAndServices").toArray()
            .filter(x => x.IsAdHoc == false);

        const columnsOptions = this.helper.loadTableColumnOptionsFromSettings(this.saveOptionKey, this.getMyleTableColumnsDefaultOptions());
        const tableRenderOptions = this.loadTableRenderOptions(columnsOptions);
        const tableColumns = this.getTableColumns(columnsOptions);

        const notificationConfig = this.props.model.get("NotificationConfiguration");

        return (
            <div className="workspace">
                <CommonTableHeaderComponent
                    title={cacheStore.GetString("ServiceComboLabel")}
                    searchText={this.props.model.get("ServiceAndComboSearchText")}
                    searchPlaceholder={cacheStore.GetString("SearchField")}
                    onSearch={text => sessionStore.dispatch(LocalOperations.AdministrationServiceCombo.SearchSettings_SearchTextChanged, { filterText: text })}
                    onRefreshClick={() => sessionStore.dispatch(LocalOperations.AdministrationServiceCombo.RefreshGrid, { reload: true })}
                    onSettingsClick={() => sessionStore.dispatch(LocalOperations.AdministrationServiceCombo.SearchSettings_Open)}
                />

                <div id="posref" className="ws-scrollable">
                    {notificationConfig?.show && (
                        <NotificationConfiguration
                            title={notificationConfig?.serviceOrCombo?.Model?.Name}
                            onSubmit={config => this.onNotificationConfigurationSubmit(config)}
                            onClose={() => sessionStore.dispatch(LocalOperations.AdministrationServiceCombo.NotificationConfiguration_Close)}
                            configuration={notificationConfig?.notificationConfiguration}
                            defaultConfiguration={notificationConfig?.defaultNotificationConfiguration}
                        />
                    )}

                    {this.props.model.get("DisplayEditServiceComponent") === true && (
                        <EditServiceComponent
                            currentEditMode={this.props.model.get("CurrentEditMode")}
                            currentEditedType={this.props.model.get("CurrentEditedType")}
                            baseDefinitionModel={this.props.model.get("EditServiceComponentModel")}
                            onCloseOperation={LocalOperations.AdministrationServiceCombo.ServiceDefinitionEdit_Close}
                        />
                    )}

                    {this.props.model.get("DisplayPortalDetailsComponent") === true && (
                        <EditOnlineDetailsComponent
                            currentEditMode={this.props.model.get("CurrentEditMode")}
                            currentEditedType={this.props.model.get("CurrentEditedType")}
                            baseDefinitionModel={this.props.model.get("EditServiceComponentModel")}
                            onCloseOperation={LocalOperations.AdministrationServiceCombo.ServiceDefinitionPortalDetailsEdit_Close}
                        />
                    )}

                    {this.props.model.get("SearchSettingsOpen") && (
                        <ServiceComboSearchSettings
                            id="servicecombosettings"
                            model={this.props.model}
                            className="filter-component filter-component-responsive"
                            refreshServiceCallBack={this.onApplySearchSettings.bind(this)}
                            onOkCallBack={this.onOkCallBack.bind(this)}
                            onCancelCallBack={this.onCloseSearchSettings.bind(this)}
                        />
                    )}

                    {this.props.model.get("ExportServiceOpen") && (
                        <ExportServicePopup
                            model={this.props.model}
                            onCancel={this.onCloseExportServices.bind(this)}
                        />
                    )}

                    <div>
                        <MyleTable
                            TableRenderOptions={tableRenderOptions}
                            TableId="adminServices_table"
                            Columns={tableColumns}
                            DataSource={services.toImmutable()}
                            RowClickOperation={LocalOperations.AdministrationServiceCombo.ServiceDefinitionEdit_Open}
                            SaveOptionskeyTarget={this.saveOptionKey}
                            ColumnReorderTarget={MyleTableTarget.Unassigned}
                            ColumnSortTarget={MyleTableTarget.Myle_AdminService_ColumnSortClick}
                        />
                    </div>

                    <div className="clearfix" />
                </div>

                <div className="ws-footer table-pager-footer flex-display flex-end">
                    <ButtonGroup>
                        {cacheStore.ClinicSettings.EnableExportTimeSlots && (
                            <ButtonControl
                                className="btn btn-default"
                                onClick={this.onOpenExportServices.bind(this)}
                                label={cacheStore.GetString("ExportTimeSlotsLabel")}
                            />
                        )}
                        <ButtonControl
                            variant="brand"
                            onClick={this.onNewServiceClick.bind(this)}
                            label={cacheStore.GetString("CreateServiceLabel")}
                        />
                        <ButtonControl
                            variant="brand"
                            onClick={this.onNewComboClick.bind(this)}
                            label={cacheStore.GetString("CreateComboLabel")}
                        />
                    </ButtonGroup>
                </div>
            </div>
        );
    }

    private getTableColumns(columnsOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        return MyleTableColumn.buildList<ServiceOrComboTableItem<IComboOrServiceItem>>(
            columnsOptions,
            column => {
                switch (column.FieldName) {
                    case "Site":
                        return {
                            renderCell: item => (
                                <div><SpanControl text={item.Site} /> </div>
                            )
                        };

                    case "Name":
                    case "Service":
                        return {
                            renderCell: item => (
                                //  update lookup in case of updates
                                // if (item.Model!=null)
                                //    item.Model.InitLookup();
                                <div><SpanControl text={item.Name} /> </div>
                            )
                        };

                    case "Type":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={item.TypeString} /> </div>
                            )
                        };

                    case "Speciality":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={item.Speciality} /> </div>
                            )
                        };

                    case "Duration":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={`${item.Duration} min`} /> </div>
                            )
                        };

                    case "Price":
                        return {
                            renderCell: item => (
                                <div> <SpanControl text={`$ ${item.Price}`} /> </div>
                            )
                        };

                    case "Details":
                        return {
                            renderCell: item => {
                                let model = item.Model as BaseServiceComboDefinitionModel;
                                let isUrgent: boolean;
                                let isAvailableOnline: boolean;
                                let isTeleconsultation: boolean;
                                let hasQuestionnaire: boolean;
                                let targetedClientele: ServiceComboTargetClientele;
                                const hasProviders: boolean = item.NbEmployees === 0;
                                if (model != null) {
                                    isUrgent = model.GetUrgency();
                                    isAvailableOnline = model.GetOnlineAvailability();
                                    targetedClientele = model.GetOnlineClienenteleCible();
                                    isTeleconsultation = cacheStore.ClinicSettings.EnableTelemedFeature && model.GetIsTeleconsultation();
                                    hasQuestionnaire = model.GetQuestionnaireId() != null;
                                }

                                return (
                                    <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                                        {isAvailableOnline && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "0px", "marginRight": "0px", "height": "30px" }} id="RVOnlineLabel_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_rdvonline} />
                                            </div>
                                        )}
                                        {isUrgent && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "0px", "marginRight": "0px", "height": "30px" }} id="RVUrgenceLabel_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_rdvurgent} />
                                            </div>
                                        )}
                                        {targetedClientele == ServiceComboTargetClientele.AssignedClientele && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "5px", "marginLeft": "3px", "height": "20px" }} id="AssignedClientele_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_assigne} />
                                            </div>
                                        )}
                                        {targetedClientele == ServiceComboTargetClientele.Clinic && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "5px", "marginLeft": "3px", "height": "20px" }} id="Clinic_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_clinique} />
                                            </div>
                                        )}
                                        {targetedClientele == ServiceComboTargetClientele.Site && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "5px", "marginLeft": "3px", "height": "20px" }} id="Site_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_site} />
                                            </div>
                                        )}
                                        {targetedClientele == ServiceComboTargetClientele.Organization && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "5px", "marginLeft": "3px", "height": "20px" }} id="Org_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_organization} />
                                            </div>
                                        )}
                                        {targetedClientele == ServiceComboTargetClientele.Open && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "5px", "marginLeft": "3px", "height": "20px" }} id="Open_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_ouvert} />
                                            </div>
                                        )}
                                        {isTeleconsultation && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "0px", "marginRight": "0px", "height": "30px" }} id="RVOnlineLabel_handle_med" src={img_icon_pictogrammemyle_emploisdutemps_teleconsultation} />
                                            </div>
                                        )}
                                        {hasQuestionnaire && cacheStore.ClinicSettings.EnableCovidQuestionnaire && (
                                            <div>
                                                <img onClick={this.openServiceComboDetails.bind(this, item)} style={{ "marginTop": "0px", "marginRight": "0px", "height": "30px" }} id="Questionnaire_handle_med" src={img_icon_questionnaire} />
                                            </div>
                                        )}

                                        {hasProviders && <div>{cacheStore.GetString("InactiveLabel")}</div>}
                                    </div>
                                );
                            }
                        };

                    case "Settings":
                        return {
                            renderCell: item => {
                                const model = item.Model as BaseServiceComboDefinitionModel;

                                return (
                                    <div className="flex-container" style={{ justifyContent: "flex-start", alignItems: "center" }}>
                                        <ButtonControl
                                            className="btn btn-link"
                                            onClick={() => this.openPortalDetails(item)}
                                            label={cacheStore.GetString("PortalLabel")}
                                        />
                                        {this.isNotificationsEnabled && !model.GetIsNotifyPatientDisabledByDefault() && (
                                            <>
                                                /
                                                <ButtonControl
                                                    className="btn btn-link"
                                                    onClick={() => this.openNotificationConfiguration(item)}
                                                    label={cacheStore.GetString("NotificationConfig_NotificationsLabel")}
                                                />
                                            </>
                                        )}
                                    </div>
                                );
                            }
                        };
                }
            },
            false // can't hide column in admin
        );
    }

    private getMyleTableColumnsDefaultOptions(): MyleTableColumnOptions[] {
        return [
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("SiteDLabel"),
                FieldName: "Site",
                IsFixedInPlace: true,
                IsSortable: true,
                RowClickEnabled: true,
                SortColumn: AdminServiceGridSortColumn.Site,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 18
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("SpecialityLabel"),
                FieldName: "Speciality",
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: AdminServiceGridSortColumn.Speciality,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 15
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("TypeLabel"),
                FieldName: "Type",
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: AdminServiceGridSortColumn.Type,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 8
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("NameLabel"),
                FieldName: "Service",
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: AdminServiceGridSortColumn.Name,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 8
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("DurationLabel"),
                FieldName: "Duration",
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: AdminServiceGridSortColumn.Duration,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 11
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("PriceLabel"),
                FieldName: "Price",
                RowClickEnabled: true,
                IsSortable: true,
                SortColumn: AdminServiceGridSortColumn.Price,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 4
            }),
            new MyleTableColumnOptions({
                HeaderText: cacheStore.GetString("DetailsLabel"),
                FieldName: "Details",
                RowClickEnabled: false,
                IsSortable: true,
                SortColumn: AdminServiceGridSortColumn.Details,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 25
            }),
            new MyleTableColumnOptions({
                HeaderText: "Settings",
                FieldName: "Settings",
                RowClickEnabled: false,
                IsSortable: false,
                SortColumn: AdminServiceGridSortColumn.Settings,
                SortDirection: SortDirection.ASC,
                WidthPercentageDefault: 11
            })
        ];
    }

    private loadTableRenderOptions(columnOptions: Immutable.List<MyleTableColumnOptions>): ITableRenderOptions {
        let defaultTablePluginOptions = {
            MinColWidth: 60,
            MinTableWidth: 980,
            Cols: columnOptions.filter(x => x.IsHidden === false).map(i => i.WidthPercentage),
            FirstColumnNoDrag: false,
            LastColumnNoDrag: false,
            Autoresize: true,
            OnColumnWidthChange: null
        };

        return Immutable.fromJS(defaultTablePluginOptions);
    }

    private onNewServiceClick(): void {
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.CreateService_Click);
        operation.AddItem("service", new ServiceDefinitionModel(null));
        LocalEventDispatcher.dispatch(operation);
    }

    private onNewComboClick(): void {
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.CreateCombo_Click);
        operation.AddItem("combo", new ServiceComboDefinitionModel(null));
        LocalEventDispatcher.dispatch(operation);
    }

    private openServiceComboDetails(item: ServiceOrComboTableItem<IComboOrServiceItem>): void {
        let itemToSend = item.Model;
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.ServiceDefinitionEdit_Open);
        operation.AddItem("rowData", itemToSend);
        LocalEventDispatcher.dispatch(operation);
    }

    private openPortalDetails(item: ServiceOrComboTableItem<IComboOrServiceItem>): void {
        let itemToSend = item.Model;
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.ServiceDefinitionPortalDetailsEdit_Open);
        operation.AddItem("rowData", itemToSend);
        LocalEventDispatcher.dispatch(operation);
    }

    private openNotificationConfiguration(serviceOrCombo: ServiceOrComboTableItem<IComboOrServiceItem>): void {
        const defaultNotificationConfiguration = cacheStore.NotificationConfiguration;

        const showDefaultNotificationConfigCheckboxes = this.props.showDefaultNotificationConfigCheckboxes && !!defaultNotificationConfiguration;

        const notificationConfiguration: NotificationConfigurationInput = {
            showDefaultConfigurationCheckboxes: showDefaultNotificationConfigCheckboxes,
            useDefaultCancelConfig: showDefaultNotificationConfigCheckboxes && !serviceOrCombo.NotificationConfiguration?.CancellationLimit && IsNullOrUndefined(serviceOrCombo.NotificationConfiguration?.EnableCancellation),
            useDefaultNotificationContent: showDefaultNotificationConfigCheckboxes && !serviceOrCombo.NotificationConfiguration?.NotificationContent,
            useDefaultReminderConfig: showDefaultNotificationConfigCheckboxes && !serviceOrCombo.NotificationConfiguration?.Reminders,
            cancellationLimit: serviceOrCombo.NotificationConfiguration?.CancellationLimit ?? defaultNotificationConfiguration.CancellationLimit,
            enableCancellation: serviceOrCombo.NotificationConfiguration?.EnableCancellation ?? defaultNotificationConfiguration.EnableCancellation,
            firstReminder: serviceOrCombo.NotificationConfiguration?.Reminders?.[0] ?? defaultNotificationConfiguration.Reminders[0],
            secondReminder: serviceOrCombo.NotificationConfiguration?.Reminders?.[1] ?? defaultNotificationConfiguration.Reminders[1],
            notificationContent: {
                En: serviceOrCombo.NotificationConfiguration?.NotificationContent?.En ?? defaultNotificationConfiguration.NotificationContent?.En ?? "",
                Fr: serviceOrCombo.NotificationConfiguration?.NotificationContent?.Fr ?? defaultNotificationConfiguration.NotificationContent?.Fr ?? "",
                Es: serviceOrCombo.NotificationConfiguration?.NotificationContent?.Es ?? defaultNotificationConfiguration.NotificationContent?.Es ?? ""
            }
        };

        sessionStore.dispatch(
            LocalOperations.AdministrationServiceCombo.NotificationConfiguration_Open,
            {
                NotificationConfiguration: {
                    show: true,
                    serviceOrCombo: serviceOrCombo,
                    notificationConfiguration: notificationConfiguration,
                    defaultNotificationConfiguration: defaultNotificationConfiguration
                } as NotificationConfigurationModal
            }
        );
    }

    private async onNotificationConfigurationSubmit(configuration: NotificationConfigurationInput): Promise<void> {
        const { serviceOrCombo } = this.props.model.get("NotificationConfiguration");

        const request: Record<string, any> = {
            Configuration: {}
        };

        if (serviceOrCombo.Model instanceof ServiceDefinitionModel) {
            request.ServicedefinitionId = serviceOrCombo.Model.Model.Id;
        }
        else if (serviceOrCombo.Model instanceof ServiceComboDefinitionModel) {
            request.ComboId = serviceOrCombo.Model.Model.ComboId;
        }
        else {
            throw new Error("Model is not a service definition or combo.");
        }

        if (!configuration.useDefaultCancelConfig) {
            request.Configuration.EnableCancellation = configuration.enableCancellation;
            request.Configuration.CancellationLimit = configuration.cancellationLimit;
        }

        if (!configuration.useDefaultReminderConfig) {
            request.Configuration.Reminders = [configuration.firstReminder, configuration.secondReminder].filter(Boolean);
        }

        if (!configuration.useDefaultNotificationContent) {
            request.Configuration.NotificationContent = {
                En: configuration.notificationContent?.En,
                Fr: configuration.notificationContent?.Fr,
                Es: configuration.notificationContent?.Es
            };
        }

        const response = await Client.postAsync<SaveNotificationConfigurationResponse>(Server.Myle_Administration_NotificationConfiguration_Save, request);

        if (!response.data.IsSuccess)
            return;

        // refresh all lookups
        if (response.data.Lookups?.length) {
            for (const lookup of response.data.Lookups)
                cacheStore.rebindLookup(new FlatLookupView(lookup));
        }

        const notificationConfiguration: NotificationConfigurationDto = response.data.NotificationConfiguration;

        if (!notificationConfiguration)
            return;

        let shouldRefresh = false;

        if (response.data.ComboId) {
            let combo = cacheStore.ServiceDefinitionComboCache.filter(p => p.Model.ComboId === response.data.ComboId).first();

            if (combo) {
                combo.Model.NotificationConfiguration = notificationConfiguration;

                cacheStore.rebindServiceComboDefinitionToCache(combo.Model);

                shouldRefresh = true;
            }
        }

        if (response.data.ServiceDefinitionId) {
            let serviceDefinition = cacheStore.ServiceDefinitionCache.filter(p => p.Model.Id === response.data.ServiceDefinitionId).first();

            if (serviceDefinition) {
                serviceDefinition.Model.NotificationConfiguration = notificationConfiguration;

                cacheStore.rebindServiceDefinitionToCache(serviceDefinition.Model);

                shouldRefresh = true;
            }
        }

        if (shouldRefresh)
            sessionStore.dispatch(LocalOperations.AdministrationServiceCombo.RefreshGrid);
    }

    private onApplySearchSettings(model: IServiceComboGridModel, reload: boolean = false, closeSettings: boolean = false): void {
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.RefreshGrid);
        operation.AddItem("model", model);
        operation.AddItem("reload", reload);
        operation.AddItem("closeSettings", closeSettings);
        LocalEventDispatcher.dispatch(operation);
    }

    private onOkCallBack(model: IServiceComboGridModel): void {
        this.onApplySearchSettings(model, false, true);
        if (model.get("SaveDisplaySettings")) {
            this.saveDisplaySettings(model);
        }
    }

    private saveDisplaySettings(model: IServiceComboGridModel): void {
        const operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.SaveDisplaySettings);
        operation.AddItem("serviceComboGridModel", model);

        LocalEventDispatcher.dispatch(operation);
    }

    private onCloseSearchSettings(): void {
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.SearchSettings_Close);
        LocalEventDispatcher.dispatch(operation);
    }

    private onOpenExportServices(): void {
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.ExportService_Open);
        LocalEventDispatcher.dispatch(operation);
    }

    private onCloseExportServices(): void {
        let operation = new LocalEvent(LocalOperations.AdministrationServiceCombo.ExportService_Close);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { NotificationConfigurationModal, ServiceComboTabView };
